import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import isEmail from 'validator/lib/isEmail';
import classNames from 'classnames';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import TextField from '@material-ui/core/TextField';

import GDPRHint from '../GDPRHint';
import { FormattedMessageWrappedInSpan } from '../../misc';

import { getFromLocalStorage } from '../../../utils/browser-storage';

const ENTER_KEY = 'Enter';

class EventReminderForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requestRaceLetter: false,
      showError: false,
      email: getFromLocalStorage('email') || '',
      startnumber: '',
    };
  }

  handleEmailInputChanged = event => {
    if (this.state.showError) {
      this.setState({
        email: event.target.value,
        showError: false,
      });
    } else {
      this.setState({ email: event.target.value });
    }
  };

  handleStartnumberInputChanged = event => {
    this.setState({ startnumber: event.target.value });
  };

  handleKeypress = event => {
    if (event.key === ENTER_KEY) {
      this.submitForm();
    }
  };

  handleCheckboxChanged = (event, checked) => {
    this.setState({ requestRaceLetter: checked });
  };

  getErrorMessage = () => {
    const { email, showError } = this.state;

    if (showError) {
      if (!email) {
        return this.props.intl.formatMessage(translations.inputErrorText);
      }

      if (!isEmail(email)) {
        return this.props.intl.formatMessage(translations.invalidEmailText);
      }
    }

    return false;
  };

  submitForm = () => {
    const { email, startnumber, requestRaceLetter } = this.state;

    if (!this.validateEmail()) {
      this.setState({ showError: true });
      return;
    }

    this.props.onRequestReminder(email, startnumber, requestRaceLetter);
  };

  validateEmail = () => {
    const { email } = this.state;
    return email && isEmail(email);
  };

  render() {
    const { intl } = this.props;

    const { startnumber, email, requestRaceLetter, showError } = this.state;

    return (
      <div className="notification-container">
	<DialogContent>
          <div className="notification-body">
            <FormGroup>
              <FormControlLabel
                classes={{ root: 'notification-checkbox' }}
                control={
                  <Checkbox
                    checked={requestRaceLetter}
                    onChange={this.handleCheckboxChanged}
                  />
                }
                label={intl.formatMessage(translations.raceletterCheckboxText)}
              />
              <TextField
                autoFocus={email === ''}
                className="notification-input"
                error={showError}
                id="email"
                helperText={this.getErrorMessage()}
                label={intl.formatMessage(translations.emailTextFieldLabel)}
                onChange={this.handleEmailInputChanged}
                onKeyPress={this.handleKeypress}
                value={email}
              />
              <TextField
                autoComplete="off"
                autoFocus={email !== ''}
                className="notification-input"
                id="startnumber"
                label={intl.formatMessage(translations.startNumberTextFieldLabel)}
                onChange={this.handleStartnumberInputChanged}
                onKeyPress={this.handleKeypress}
                placeholder={intl.formatMessage(translations.startNumberTextFieldPlaceholder)}
                value={startnumber}
              />
            </FormGroup>
            <div className="mt-30 center-text">
              <GDPRHint />
            </div>
          </div>
	</DialogContent>
	<DialogActions>
          <div className="notification-action">
            <button
              className={classNames('accept', { disabled: !this.validateEmail })}
              onClick={this.submitForm}
            >
              <FormattedMessageWrappedInSpan
                id="eventReminderForm.acceptButton"
                defaultMessage="Notify me"
              />
            </button>
          </div>
	</DialogActions>
      </div>
    );
  }
}

const translations = defineMessages({
  emailTextFieldLabel: {
    id: 'eventReminderForm.emailTextFieldLabel',
    defaultMessage: 'Email',
  },
  startNumberTextFieldLabel: {
    id: 'eventReminderForm.startNumberTextFieldLabel',
    defaultMessage: 'Start Number (Optional)',
  },
  startNumberTextFieldPlaceholder: {
    id: 'eventReminderForm.startNumberTextFieldPlaceholder',
    defaultMessage: 'Enter one or more start numbers (unhyphenated)',
  },
  raceletterCheckboxText: {
    id: 'eventReminderForm.raceletterCheckboxText',
    defaultMessage:
      'Subscribe to the Sportograf Raceletter. I can revoke this consent at any time with effect for the future by sending an email to support@sportograf.com.',
  },
  inputErrorText: {
    id: 'eventReminderForm.inputErrorText',
    defaultMessage: 'This field is required',
  },
  invalidEmailText: {
    id: 'eventReminderForm.invalidEmailText',
    defaultMessage: 'Please enter a valid email',
  },
});

EventReminderForm.propTypes = {
  onRequestReminder: PropTypes.func,
  intl: PropTypes.object,
};

export default injectIntl(EventReminderForm);
